import * as React from 'react'
import { Image } from 'react-bootstrap'
import config from '../../../../constants/config'

import styleRules from '../../../../utils/styleRules'
import images from '../../../../constants/images'
import { UserT } from '../../../../types/Users'
import { InputAutoComplete } from '../../../../components/InputAutoComplete'
import { keyGenerator } from '../../../../utils'
import { AxiosInstance } from '../../../../utils/RequestMethods'
declare const { defaultValue, value, ...inputAttributes }: React.InputHTMLAttributes<HTMLInputElement>;
type InputAttributes = typeof inputAttributes;

const UserObj = {
    id: null,
    address: '',
    address2: '',
    billingContact: null,
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    profilePic: '',
}

export interface IInputSearchUsersProps extends InputAttributes {
    textValue?: string
    onSelectUser?(user: UserT): void
    isShow?: boolean
    // query?: {
    //     roles?: Array<string>
    // }
    onChange?(event: any): void
    disabled?: boolean
    autoHide?: boolean
    onChangeText?(text: string): void
    className?: string
    style?: any
    placeholder?: string
}

const InputSearchClients: React.FC<IInputSearchUsersProps> = (props) => {
    const [textValue, setTextValue] = React.useState('')
    const [itemSelected, setItemSelected] = React.useState(false)
    const [isSearched, setIsSearched] = React.useState(false)

    React.useEffect(() => {

        if (props.textValue != textValue) {
            setTextValue(props.textValue)
        }
    }, [props.textValue])



    //
    const searchUsers = async (search) => {
        let params = {
            'search': search,

        }
        // if (props.query && props.query.roles) {
        //     params['roles'] = props.query.roles
        // }
        let options={
          data:params
        }
        return AxiosInstance.get(`${config.url.clients}`, options).then((res) => {
            if (res && res.data) {
                return res.data;
            }
            return []
        })
    }


    /**
     *
     * @param row
     */
    const onSelectUser = (row) => {

        setTextValue(row.place_name)
        // hide list display
        stopSearching();

        setItemSelected(row)

        if (props.onSelectUser) {
            const user = { ...UserObj, ...row }
            setTextValue(`${user.email}`)
            props.onSelectUser(user)
        }
    }

    const stopSearching = () => {
        setIsSearched(!isSearched)
    }


    const renderRowSearch = (row, index) => {
        return (
            <div key={index + "" + keyGenerator()} className="cursor" style={{ padding: 5 }}>
                <div className="" style={{
                    // padding: 5,
                    // margin: 5,
                    borderBottomColor: "#eee", borderBottomWidth: 1
                }}
                    // type={"button"}
                    onClick={() => onSelectUser(row)}>
                    <div className="d-flex flex-row">
                        <Image roundedCircle
                            style={{ width: 60, height: 60 }}
                            src={row.profilePic ? row.profilePic : images.noProfilePic}
                        //     alt={`${row.meta.first_name}
                        //    ${row.meta.last_name}`}
                        />

                        <div className="d-flex flex-column" style={{ marginLeft: 5 }}>
                            <span> {row.firstName ? row.firstName : ''} {row.lastName ? row.lastName : ''}</span>

                            <span> {row.email}</span>

                        </div>

                    </div>
                </div>
            </div >

        )
    }
    return (
        <InputAutoComplete
            disabled={props.disabled}
            className={props.className}
            style={styleRules({ ...{ margin: 0 }, ...props.style })}
            editable={!props.isShow}
            searchData={searchUsers}
            textValue={`${textValue}`}
            onChange={props.onChange}
            onChangeText={(text) => {
                setTextValue(text)
                if(props.onChangeText){
                    props.onChangeText(text)
                }
            }}
            renderRow={renderRowSearch}
            // renderRows={renderItemsSearch}
            stopSearching={isSearched}
            placeholder={props.placeholder}
            autoHide={false}
        />
    )
}

InputSearchClients.defaultProps = {
    className: "input-material",
    style: null,
    placeholder: '',
    isShow: false,
    disabled: false,
    autoHide: true,

}

export default InputSearchClients
export { InputSearchClients }
